<div class="__component mb-3">
  <button class="btn btn-secondary btn-block d-flex justify-content-between align-items-center"
          [disabled]="disabled"
          (click)="collapse = !collapse">
    <span>{{selectedCages}} jaulas seleccionadas</span>
    <i class="fa" [ngClass]="collapse ? 'fa-caret-down' : 'fa-caret-up'"></i>
  </button>

  <div class="__collapseContainer" [ngClass]="{'collapse': collapse}">
    <div class="__listContainer">
      <div class="__listItem"
           *ngFor="let cage of cages"
           (click)="selectItem(cage)">
        <div class="row">
          <div class="col-sm-1">
            <i class="fa fa-check" *ngIf="cage.IsSelected"></i>
          </div>
          <div class="col-sm-2">
            <b>{{cage.CageInfo}}</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
